/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PostOpRecoveryDischarge from './post-op-recovery-discharge';
import PostOpRecoveryDischargeDetail from './post-op-recovery-discharge-detail';
import PostOpRecoveryDischargeUpdate from './post-op-recovery-discharge-update';
import PostOpRecoveryDischargeDeleteDialog from './post-op-recovery-discharge-delete-dialog';

const PostOpRecoveryDischargeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PostOpRecoveryDischarge />} />
    <Route path="new" element={<PostOpRecoveryDischargeUpdate />} />
    <Route path=":id">
      <Route index element={<PostOpRecoveryDischargeDetail />} />
      <Route path="edit" element={<PostOpRecoveryDischargeUpdate />} />
      <Route path="delete" element={<PostOpRecoveryDischargeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PostOpRecoveryDischargeRoutes;
